import React, { useMemo } from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../styles";
import { buildScreeningExportRows } from "../../helpers/complianceExport";
import { ComplianceTable, SectionTitle } from "../../shared";

const ComplianceScreeningSection = ({ t, supplierData = {}, meta }) => {
    const screeningRows = useMemo(
        () => buildScreeningExportRows(supplierData?.complianceScreening, { t }),
        [supplierData?.complianceScreening, t]
    );

    return (
        <View style={styles.wordSectionContent}>
            <ComplianceTable
                leading={(
                    <SectionTitle
                        title={meta?.title || "Compliance Screening"}
                        number={meta?.number}
                        anchorId={meta?.anchorId}
                    />
                )}
                rows={screeningRows}
            />
        </View>
    );
};

export default withNamespaces()(ComplianceScreeningSection);
